/**
 * LiveMeetingNotificationProvider - workspace-level live meeting session context.
 *
 * Opens a WebSocket to the live meeting service for the current workspace and
 * publishes the session state via LiveMeetingSessionContext so that any
 * descendant (AppNav, page headers, LiveMeetingBadge, LiveMeetingPane) can
 * read live meeting status without opening a second WebSocket connection.
 *
 * The toast notification has been replaced by the persistent LiveMeetingBadge
 * in each page header, which avoids the multi-tab dismiss problem.
 */

import * as React from 'react';
import { useWorkspace } from '../../../contexts/WorkspaceContext';
import { LiveMeetingSessionContext } from '../contexts/LiveMeetingSessionContext';
import { useLiveMeetingSession } from '../hooks/useLiveMeetingSession';

export function LiveMeetingNotificationProvider({ children }: { children: React.ReactNode }) {
  const { workspace, activeModuleKey } = useWorkspace();
  const session = useLiveMeetingSession(workspace?.uuid, activeModuleKey);

  return (
    <LiveMeetingSessionContext.Provider value={session}>
      {children}
    </LiveMeetingSessionContext.Provider>
  );
}
